import React from "react";
import { Route } from "react-router-dom";
import PublicLayout from "layouts/publicLayout";

const PublicRoute = ({ component: Component, formType, formSubtype, productType, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <PublicLayout formType={formType}>
          <Component {...props} formType={formSubtype} productType={productType} />
        </PublicLayout>
      )}
    />
  );
};

export default PublicRoute;
